import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { ParametroAdm } from '../models/parametro-adm-model';
import { ApiService } from '../api/api.service';

@Injectable({
  providedIn: 'root'
})
export class ValidacaoCadastroService {
  private readonly url = `${environment.apiURLService}/v1`;

  constructor(
    private http: HttpClient,
    private apiService: ApiService
  ) { }

  async enviarToken(telefone: string): Promise<void> {
    const url = this.apiService.getEndpoint({
      apiKey: 'cdc-cobranca',
      path: '/cobranca/clientes/validacao-cadastro/token',
      oldBrowserFallbackPath: '/clientes/validacao-cadastro/token'
    })

    return this.http.post<void>(url, { telefone }).toPromise();
  }

  async confirmarToken(telefone: string, token: string): Promise<void> {

    const data = { telefone, token: token.toLowerCase() };
    const url = this.apiService.getEndpoint({
      apiKey: 'cdc-cobranca',
      path: '/cobranca/clientes/validacao-cadastro/atualizar',
      oldBrowserFallbackPath: '/clientes/validacao-cadastro/atualizar'
    })
    return this.http.post<void>(url, data).toPromise();
  }

  async buscarParametroTentativas(): Promise<ParametroAdm> {

    const url = this.apiService.getEndpoint({
      apiKey: 'cdc-cobranca',
      path: '/cobranca/parametros/confirmacaoDadosCadastrais/tentativas',
      oldBrowserFallbackPath: '/parametros/confirmacaoDadosCadastrais/tentativas'
    })

    return this.http.get<ParametroAdm>(url).toPromise();
  }

}
